import React from 'react';
import { motion } from 'framer-motion';
import { Map, FileText, Phone, RefreshCw } from 'lucide-react';
const maps = [{
  icon: Map,
  title: 'MAP 1 — Funding Map',
  question: 'What do I have & what does it mean?',
  desc: 'No jargon. No interpretations. Just clarity and priorities.'
}, {
  icon: FileText,
  title: 'MAP 2 — Evidence Map',
  question: 'What evidence do I need?',
  desc: 'Templates to request reports/letters without sounding confused or desperate.'
}, {
  icon: Phone,
  title: 'MAP 3 — Provider Map',
  question: 'Who do I call & in what order?',
  desc: "Tracker, call scripts, and a follow-up plan for waitlists so you don't burn out."
}, {
  icon: RefreshCw,
  title: 'MAP 4 — Review Map',
  question: "What if it's not enough?",
  desc: 'Minimal weekly log + structure to be ready if you need a review.'
}];
export function FourMaps() {
  return <section className="py-20 bg-cream-50" data-id="element-33">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-35">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-36">
            Introducing: The 4-Map System
          </h2>
          <p className="text-lg text-gray-600" data-id="element-37">
            Instead of trying to "understand NDIS" as a whole, you'll build 4
            specific maps. Each map answers a single question, so your mind
            stops spinning.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-38">
          {maps.map((map, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100" data-id="element-39">
              <div className="h-12 w-12 bg-teal-100 rounded-xl flex items-center justify-center mb-6 text-teal-600" data-id="element-40">
                <map.icon className="h-6 w-6" data-id="element-41" />
              </div>
              <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-42">
                {map.title}
              </h3>
              <p className="text-teal-600 font-medium mb-3 text-sm" data-id="element-43">
                {map.question}
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-44">{map.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}